module.exports = __webpack_public_path__ + "static/img/16bg_3.e7eb813.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/16bg_3.png
// module id = 659
// module chunks = 1